/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown>, position: NonNullable<unknown>, total: NonNullable<unknown> }} Practice_Drag_StartInputs */



/**
* | output |
* | --- |
* | "{title} picked up. Position {position} of {total}." |
*
* @param {Practice_Drag_StartInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_drag_start = /** @type {((inputs: Practice_Drag_StartInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Drag_StartInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`${i?.title} opgepakt. Plaats ${i?.position} van ${i?.total}.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.title} pris. Position ${i?.position} sur ${i?.total}.`)
	return /** @type {LocalizedString} */ (`${i?.title} picked up. Position ${i?.position} of ${i?.total}.`)
});